// src/types/hermes.types.ts

export type RuntimeName = 'hermes' | 'quant' | 'knowledge' | 'business' | 'agent';
import { WorkspaceView } from './workspace';

export enum HermesIntent {
  Chat = 'chat',
  Trading = 'trading',
  Knowledge = 'knowledge',
  Business = 'business',
  Workspace = 'workspace',
  Agent = 'agent',
  Browser = 'browser',
  Summarize = 'summarize',
  Translate = 'translate',
  Plan = 'plan',
  Analyze = 'analyze',
  Content = 'content',
  Publish = 'publish',
  Xiaohongshu = 'xiaohongshu',
  // P2-1 新增：无人值守定时任务意图
  AutoAgent = 'auto_agent',
  // Sprint 1 Task 4 新增：内容日历排期意图
  Calendar = 'calendar',
  // Sprint 1 Task 5 新增：AI 编辑部意图（多 Agent 协作内容生产流水线）
  Editorial = 'editorial',
  // Sprint 1 Task 8 新增：视频生成流水线意图（文章→脚本→分镜→TTS→数字人→字幕→合成→发布）
  VideoPipeline = 'video_pipeline',
  // Sprint 2 Task 2 新增：知识图谱意图（真 Graph，客户→购买→SKU→SOP→Workflow→Memory→Content）
  KnowledgeGraph = 'knowledge_graph',
  // Sprint 2 Task 4 新增：AI CEO 日报意图（每晚 22:00 自动生成 / 查询 CEO 日报）
  CEOReport = 'ceo_report',
  // Sprint 2 Task 5 新增：AI 销售跟进意图（客户分级 / 跟进策略 / 多渠道触达 / 效果分析）
  SalesFollowUp = 'sales_followup',
  // Sprint 4 Phase A 新增：CRM / SKU / SOP 企业知识查询意图
  CRM = 'crm',
  SKU = 'sku',
  SOP = 'sop',
  // Sprint 4 Phase B/C/D 新增：内容工厂 / 销售 / 高管团队意图
  ContentFactory = 'content_factory',
  SalesClose = 'sales_close',
  Executive = 'executive',
  // Sprint 4 P0-4 新增：SKU 联动意图（SKU↔SOP↔Content↔CRM 联动）
  // 用户场景："哪个 SKU 卖得最好"、"给 AI 培训生成内容"、"买过 AI 咨询的客户"
  SKULinkage = 'sku_linkage',
  // Sprint 4 Obsidian Knowledge Growth 新增：知识库自动成长意图
  // 用户场景："执行知识库成长"、"立即生成今日调研"、"跑一下知识沉淀"
  KnowledgeGrowth = 'knowledge_growth',
  // Sprint 7 阶段 9 新增：AI 公司闭环意图（16 阶段运营闭环）
  // 用户场景："跑 AI 公司闭环"、"执行今日运营"、"补跑 CEO 简报阶段"
  Corporate = 'corporate',
  // Sprint 8 Epic 5 新增：企业运营官意图（每日 8 项检查 / 运营报告 / 补救动作）
  // 用户场景："跑运营检查"、"看今日运营报告"、"运营官简报"、"运营官补救"
  Operator = 'operator',
  // 新增：媒体工作室意图（生成自媒体内容 / 脚本 / 封面 / 关联营销中心）
  // 用户场景："生成抖音脚本"、"生成公众号文章"、"生成小红书笔记"、"生成B站视频脚本"、"生成知乎回答"
  MediaStudio = 'media_studio',
  // 新增：营销中心意图（查看营销数据 / GEO+DSO 启动 / 平台配置）
  // 用户场景："查看营销数据"、"启动 GEO+DSO"、"看公众号配置"
  Marketing = 'marketing',
  Unknown = 'unknown',
}

export type MessageStatus = 'idle' | 'loading' | 'streaming' | 'success' | 'error';

export interface HermesMessage {
  id: string;
  role: 'user' | 'assistant' | 'system';
  content: string;
  status: MessageStatus;
  timestamp: string;
  intent?: HermesIntent;
  runtime?: RuntimeName;
  view?: WorkspaceView;
  payload?: unknown;
  widgets?: string[];
  error?: string;
}

export interface HermesResponse {
  intent: HermesIntent;
  response: string;
  view?: WorkspaceView;
  payload?: unknown;
  widgets?: string[];
  runtime?: RuntimeName;
  error?: string;
}

export interface HermesCommand {
  id: string;
  label: string;
  icon?: string;
  command: string;
  runtime?: RuntimeName;
  view?: WorkspaceView;
  category?: string;
  disabled?: boolean;
}

export interface HermesConversation {
  id: string;
  title: string;
  messages: HermesMessage[];
  createdAt: string;
  updatedAt: string;
}